import React, { Component } from 'react';
import Source from './Source';


class Sources extends React.Component {

  render() {
    var territory = this.props.territory;

    return(
      <div className="row">
        <div className="col">

          <div className="row mt-5 ">
            <div className="col-12">
              <h2 className="line">sources</h2>
            </div>
          </div>


            <div className="row mt-3 mb-5">
              <div className="col-12">
              {
                Object.keys(territory.sources).map((s_name)=>
                  <Source name={s_name} sources={territory.sources}/>
              )
              }
              </div>
            </div>

        </div>
      </div>
    )
  }
}

export default Sources;
